<template>
    <b-card v-if="schedule">
        <h4>
            Event schedule
            <b-badge style="float: right">
                <i class="fa fa-calendar"></i>
            </b-badge>
        </h4>        
        <div v-for="d in schedule.dates" v-bind:key="d.id">
            {{ new Date(d.start).toLocaleString() }} - {{ new Date(d.end).toLocaleString() }}
            <router-link :to="{name: 'guestsList', params: {event_id: event_id, schedule_id: d.id, type: 'attendee', mode: 'add'}}">
                <i class="fa fa-user-plus"></i>
            </router-link>
            <br />
            <router-link :to="{name: 'guestsList', params: {event_id: event_id, schedule_id: d.id, type: 'registrant'}}">
                <i class="fa fa-filter" title="registrant"></i> registrant
            </router-link>
            <br />
            <router-link :to="{name: 'guestsList', params: {event_id: event_id, schedule_id: d.id, type: 'attendee'}}">
                <i class="fa fa-filter" title="attendee"></i> attendee
            </router-link>
            <br />
            <router-link :to="{name: 'guestsList', params: {event_id: event_id, schedule_id: d.id, type: 'canceled'}}">
                <i class="fa fa-filter" title="canceled"></i> canceled
            </router-link>
        </div>
    </b-card>
</template>

<script>
import axios from "axios";

export default {
    name: "eventSchedule",
    props: ["event_id"],
    data: () => {
        return {
            resources: {
                events: "/events",
                schedule: "/schedule"
            },
            schedule: {}
        };
    },
    methods: {
        fetchData(resource, options) {
            return axios
                .get(this.$store.getters.apiBase + this.$data.resources.events + "/" + this.$props["event_id"] +  this._data.resources.schedule, {
                    headers: {
                        "Content-Type": "application/json",
                        
                        Authorization: this.$store.getters.accessToken,
                        account_id: this.$store.getters.accountId
                    }
                })
                .then(response => {
                    this.$data.schedule = response.data;
                    return response;
                })
                .catch(response => {
                    console.log(response);
                });
        }
    },
    watch: {
        "$route": "fetchData"
    },
    computed: {
        
    },
    created() {
        this.fetchData();
    }
};
</script>